import { Directive, ElementRef, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[appRadialGradient]',
  standalone: true,
})
export class RadialGradientDirective implements OnInit, OnChanges {
  @Input('appRadialGradient') colors: string[] | undefined;

  constructor(private el: ElementRef<HTMLElement>) {}

  ngOnInit(): void {
    // Applique automatiquement la classe CSS pour le gradient radial
    this.el.nativeElement.classList.add('radial-gradient-image-placeholder');
    this.applyGradientStyles();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['colors']) {
      this.applyGradientStyles();
    }
  }

  private applyGradientStyles(): void {
    const element = this.el.nativeElement;

    if (!this.colors || !Array.isArray(this.colors) || this.colors.length === 0) {
      // Supprime les variables CSS personnalisées pour revenir aux valeurs par défaut
      element.style.removeProperty('--radial-color-start');
      element.style.removeProperty('--radial-color-middle');
      element.style.removeProperty('--radial-color-end');
      return;
    }

    // Utilise la couleur principale comme couleur de début
    if (this.colors[0]) {
      element.style.setProperty('--radial-color-start', this.colors[0]);
    }

    // Utilise la deuxième couleur comme couleur du milieu, ou la première si pas de deuxième
    if (this.colors[1]) {
      element.style.setProperty('--radial-color-middle', this.colors[1]);
    } else if (this.colors[0]) {
      element.style.setProperty('--radial-color-middle', this.colors[0]);
    }

    // Utilise la troisième couleur comme couleur de fin, ou la deuxième, ou la première
    if (this.colors[2]) {
      element.style.setProperty('--radial-color-end', this.colors[2]);
    } else if (this.colors[1]) {
      element.style.setProperty('--radial-color-end', this.colors[1]);
    } else if (this.colors[0]) {
      element.style.setProperty('--radial-color-end', this.colors[0]);
    }
  }
}
